import DropzoneUploader from "components/dropzone";
import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Spinner,
} from "reactstrap";
import { translate } from "react-switch-lang";

function ImportDataModal(props) {
  const [file, setFile] = useState([]);

  const toggle = () => props.setShow(!props.show);

  const onImport = () => {
    props.onImport(file[0]);
  }

  return (
    <Modal centered isOpen={props.show} toggle={toggle} {...props}>
      <ModalHeader toggle={toggle}>Import Data</ModalHeader>
      <ModalBody>
        <Label className="fw-bold">Select or Drag .xlsx file</Label>
        <DropzoneUploader onChange={setFile} />
      </ModalBody>
      <ModalFooter>
        <Button disabled={!file.length} color="primary" onClick={onImport}>
          {props.loading ? <Spinner size="sm" /> : props.t("Import Data")}
        </Button>
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default translate(ImportDataModal);
